import React, {ChangeEvent, MouseEvent} from "react";
import LoginCheckbox from "./LoginCheckbox";
import styled from "styled-components";
import {White} from "../../Constants/ColorChart";

const StyledLabel = styled.label`
  border: none;
  width: 90%;
  color: ${White};
  padding-right: 5%;
  display: inline-block;
  padding-top: 2%;
  padding-bottom: 2%;
  margin-right: 0;
  font-size: 15px;
  text-decoration: underline;
  &::placeholder {
    color: ${White};
  }
  &:focus {
    outline: none;
  }
`;

type LoginTermsProps = {
    checked: boolean;
    handleChange: (event: ChangeEvent<HTMLInputElement>) => void;
    handleClick: (event: MouseEvent<HTMLSpanElement>) => void;
};

const LoginTerms: React.FC<LoginTermsProps> = ({checked, handleChange, handleClick}) => {
    return (
        <div>
            <StyledLabel>
                <LoginCheckbox checked={checked} handleChange={handleChange}/>
                <span onClick={handleClick}>
                    {'He leído los términos y condiciones del acceso'}
                </span>
            </StyledLabel>
        </div>
    );
};

export default LoginTerms;